module.exports = __webpack_public_path__ + "img/nichongming.f51c03bd.png";